/**
 * Bot wallet view helpers (infrastructure spec 2026-10-14-llm-usage-flows §9.8, LLM usage phase 1a): the balance,
 * its ledger, and the global admins' top-up / correction forms. Pure, tested in tests/walletView.test.ts.
 */
export type WalletTxType = 'topup' | 'adjust' | 'deduct';

export function formatMnt(v: number): string {
  const n = Number(v) || 0;
  return `${n.toLocaleString('en-US', { maximumFractionDigits: 4 })}₮`;
}

export function txLabel(type: WalletTxType): string {
  return type === 'topup' ? 'Top-up' : type === 'adjust' ? 'Correction' : 'AI usage';
}

export type FormErrors = Partial<Record<'amount' | 'ref' | 'note', string>>;

export function validateTopUp(f: { amount: string; ref: string }): FormErrors {
  const e: FormErrors = {};
  const n = Number(f.amount);
  if (!f.amount.trim() || !Number.isFinite(n) || n <= 0) e.amount = 'Enter an amount above 0';
  if (!f.ref.trim()) e.ref = 'Enter the bank or invoice reference';
  return e;
}

export function validateAdjust(f: { amount: string; ref: string; note: string }): FormErrors {
  const e: FormErrors = {};
  const n = Number(f.amount);
  if (!f.amount.trim() || !Number.isFinite(n) || n === 0) e.amount = 'Enter a non-zero amount';
  if (!f.ref.trim()) e.ref = 'Enter a reference for this correction';
  if (!f.note.trim()) e.note = 'Say why';
  return e;
}

/** The wallet routes' refusals in plain words; null = show the generic error. */
export function conflictMessage(status: number): string | null {
  if (status === 409) return 'This reference was already recorded with a different amount';
  if (status === 422) return 'The balance cannot go below 0';
  if (status === 403) return 'Only global admins can record top-ups';
  return null;
}
